// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2yK2k","title":"BackImages_title__2k6hg","images":"BackImages_images__2qg5h"};